import _slicedToArray from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * @file EfScrollAni
 * @author shengzhao
 * @desc 控制滚动条触发的动画库
 * @version v1.0.0
 */

import BezierFactory from "./BezierFactory";
import * as Ease from "./Ease";
import { $M } from "./Matrix";
import { convertToCss, getScrollTop, isString, roundFloat } from "./utils";
var log = function log() {};
var STATE_BEFORE = 'before';
var STATE_AFTER = 'after';
var STATE_DURING = 'during';
var STATE_CSS_BOUNDS_ARRAY = ['width', 'height', 'top', 'left', 'right', 'bottom', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom'];
var START_WILL_CHANGE_TOP = 380;
var END_WILL_CHANGE_TOP = 200;
var LAZY_HOOK = 2;
function EfScrollAni(container) {
  this.controller(container);
}

// 全页面只有一个控制器
EfScrollAni.prototype.controller = function (container) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  var _this = this;
  _this.scenesArr = []; // dom动画元素集合
  _this.scenesArrLen = 0; // dom动画元素集合长度
  _this.isRunning = false;
  _this.updateTime = 80; // 用于control初始化更新绑定的create

  // 帧率
  // 添加bind(window) 防止Illegal invocation"
  _this.rAF = window.requestAnimationFrame.bind(window);
  _this.cAF = window.cancelAnimationFrame.bind(window);

  // 控制器滚动条值
  _this.container = container ? document.querySelector(container) : undefined;
  _this.container_height = _this.container ? _this.container.clientHeight : document.documentElement.clientHeight;
  _this.container_top = _this.container ? _this.container.getBoundingClientRect().top : 0;
  _this.ScrollTop = getScrollTop(_this.container);
  _this.prevScrollTop = _this.ScrollTop;

  // 当前滚动的区间下标&滚动方向
  _this.currentIndex = 0;
  _this.isUpdate = false;

  // 控制器的scene下标
  _this.containerSceneIndex = 0;
  this.scrollFn = _this.scrollHandle.bind(_this);
  (_this.container || window).addEventListener('scroll', this.scrollFn);
  (_this.container || window).addEventListener('resize', this.scrollFn);
  window.setTimeout(_this.scrollFn, _this.updateTime);
};

// 数据初始化
EfScrollAni.prototype.create = function (options) {
  var _scene$triggerElement;
  var _this = this;
  _this.containerSceneIndex++; // id唯一递增
  var scene = {};
  if (typeof window === 'undefined') {
    return {
      destroy: function destroy() {}
    };
  }
  scene.id = _this.containerSceneIndex;
  try {
    scene.triggerElement = isString(options.triggerElement) ? document.querySelector(options.triggerElement) : options.triggerElement;
    if (!scene.triggerElement) {
      throw ["triggerElement is null & className is ".concat(options.triggerElement)];
    }
  } catch (error) {
    //throw new Error(error);
  }
  if (!scene.triggerElement) {
    return {
      destroy: function destroy() {}
    };
  }
  scene.offset = options.offset || 0;
  scene.triggerHook = options.triggerHook || 0; // 1 进入, 0 离开
  scene.duration = options.duration || 0; // 滚动条控制距离，如果是0即只启动
  scene.scrollUpdatePos = options.scrollUpdatePos || false; // 滚动时更新目标元素的最新位置

  // 是否启用GPU通过will-change
  scene.isGpu = options.isGpu === false ? false : true;

  // 同步执行
  scene.syncFromTo = options.syncFromTo || [];
  if (scene.syncFromTo.length > 0) {
    scene.syncArrDom = scene.syncFromTo.map(function (item) {
      var dom = null;
      try {
        dom = isString(item[0]) ? document.querySelector(item[0]) : item[0];
        if (!dom) {
          throw ["dom is null & className is ".concat(item[0])];
        }
      } catch (error) {
        throw new Error(error);
      }
      return {
        dom: dom,
        className: dom.className
      };
    });
  }

  // 异步执行
  scene.asyncFromTo = options.asyncFromTo || [];
  if (scene.asyncFromTo.length > 0) {
    scene.asyncClassMap = new Map();
    scene.asyncArrDom = scene.asyncFromTo.map(function (item, index) {
      var _dom;
      var className = item[0];
      // 甄别同一个异步中是否存在两个相同的dom节点
      var multiple = false;
      if (scene.asyncClassMap.has(className)) {
        var _arrClassIndex2 = scene.asyncClassMap.get(className);
        _arrClassIndex2.push(index);
        multiple = true;
      } else {
        scene.asyncClassMap.set(className, [index]);
      }
      var dom = null;
      try {
        dom = isString(className) ? document.querySelector(className) : className;
        if (!dom) {
          throw ["dom is null & className is ".concat(className)];
        }
      } catch (error) {
        throw new Error(error);
      }
      return {
        dom: dom,
        multiple: multiple,
        className: (_dom = dom) === null || _dom === void 0 ? void 0 : _dom.className
      };
    });
    scene.asyncTotalDuration = scene.asyncFromTo.reduce(function (total, item) {
      return total + (item[3] || 1);
    }, 0);
    scene.asyncTimeLine = options.asyncTimeLine || [];

    // 时间总时长需根据时间线来变更
    if (scene.asyncTimeLine.length > 0) {
      var _maxTotalDuration2 = -100;
      for (var _i = 0; _i < scene.asyncTimeLine.length; _i++) {
        var _value2 = scene.asyncFromTo[_i][3] + scene.asyncTimeLine[_i];
        if (_maxTotalDuration2 < _value2) {
          _maxTotalDuration2 = _value2;
        }
      }
      scene.asyncTotalDuration = _maxTotalDuration2;
    } else {
      var _total2 = 0;
      var _prevItem2 = null;
      scene.asyncTimeLine = scene.asyncFromTo.map(function (item, index) {
        if (index == 0) {
          _prevItem2 = item;
          return _total2;
        }
        _total2 += _prevItem2[3] || 1;
        _prevItem2 = item;
        return _total2;
      });
    }

    // console.log('scene.asyncTimeLine', scene.asyncTimeLine);
    var _asyncArrDuration2 = [];
    for (var _i2 = 0; _i2 < scene.asyncFromTo.length; _i2++) {
      var _block2 = {
        start: 0,
        end: 0
      };
      var _start2 = scene.asyncTimeLine[_i2];
      _block2.start = _start2 / scene.asyncTotalDuration;
      _block2.end = (_start2 + (scene.asyncFromTo[_i2][3] || 1)) / scene.asyncTotalDuration;
      _block2.duration = _block2.end - _block2.start;
      _asyncArrDuration2.push(_block2);
    }

    // console.log('asyncArrDuration', asyncArrDuration);
    scene.asyncArrDuration = _asyncArrDuration2;
  }
  if (String(scene.duration).indexOf('%') > -1) {
    var _duration2 = scene.duration;
    scene.duration = roundFloat(Number(_duration2.slice(0, _duration2.length - 1) / 100) * this.container_height, 0);
  }
  if (String(scene.offset).indexOf('%') > -1) {
    var _offset2 = scene.offset;
    scene.offset = roundFloat(Number(_offset2.slice(0, _offset2.length - 1) / 100) * this.container_height, 0);
  }

  // triggerHook
  scene.box = (_scene$triggerElement = scene.triggerElement) === null || _scene$triggerElement === void 0 ? void 0 : _scene$triggerElement.getBoundingClientRect();
  var startTop = 0;
  scene.baseTopValue = -this.container_top - this.container_height * scene.triggerHook + scene.offset;
  startTop = scene.box.top + this.ScrollTop + scene.baseTopValue;
  scene.startTop = startTop < 0 ? 0 : startTop;
  scene.endTop = scene.startTop + scene.duration;

  // will-change 触发时机提前和延后消失
  if (scene.isGpu) {
    scene.wcStartTop = scene.startTop - START_WILL_CHANGE_TOP;
    scene.wcEndTop = scene.endTop + END_WILL_CHANGE_TOP;
    scene.wcState = STATE_BEFORE;
    scene.prevWcState = STATE_BEFORE;
    scene.wcStateChange = false;
  }
  scene.percent = 0;
  scene.prevPercent = -1;

  // 进入 离开
  scene.onEnter = options.onEnter;
  scene.onLeave = options.onLeave;
  scene.state = STATE_BEFORE;
  scene.prevState = STATE_BEFORE;
  scene.stateChange = false;

  // 进程中 0～1
  scene.onProcess = options.onProcess;

  // 提供scene的延迟加载 针对video、等大资源文件
  scene.onLazyLoad = options.onLazyLoad;
  scene.lazyStartTop = (options.lazyHook || LAZY_HOOK) * this.container_height;

  // destroy
  scene.destroy = function () {
    _this.removeScene(scene);
  };
  this.scenesArr.push(scene);
  this.scenesArrLen = this.scenesArr.length;
  return scene;
};
EfScrollAni.prototype.scrollHandle = function (e) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  var _this = this;
  if (!_this.isUpdate) {
    _this.isUpdate = true;
    _this.updateTimeout = _this.rAF(_this.update.bind(_this));
  }
};
EfScrollAni.prototype.start = function () {
  this.isRunning = true;
};
EfScrollAni.prototype.update = function () {
  if (!this.isUpdate) return;
  this.isUpdate = false;
  this.ScrollTop = getScrollTop(this.container);
  for (var _i3 = 0; _i3 < this.scenesArrLen; _i3++) {
    var _scene2 = this.scenesArr[_i3];
    if (_scene2.scrollUpdatePos) {
      var _scene2$triggerElemen;
      _scene2.box = (_scene2$triggerElemen = _scene2.triggerElement) === null || _scene2$triggerElemen === void 0 ? void 0 : _scene2$triggerElemen.getBoundingClientRect();
      var _startTop3 = 0;
      _startTop3 = _scene2.box.top + this.ScrollTop + _scene2.baseTopValue;
      _scene2.startTop = _startTop3 < 0 ? 0 : _startTop3;
      _scene2.endTop = _scene2.startTop + _scene2.duration;
    }
    var _startTop5 = _scene2.startTop;
    var _endTop2 = _scene2.endTop;
    var _duration4 = _scene2.duration;
    var _outLoop2 = false;
    var _percent2 = 0;
    if (this.ScrollTop < _startTop5) {
      _percent2 = 0;
      _outLoop2 = true;
      _scene2.state = STATE_BEFORE;
    } else if (this.ScrollTop > _endTop2) {
      _percent2 = 1;
      _scene2.state = STATE_AFTER;
    } else {
      _scene2.state = STATE_DURING;
      _percent2 = roundFloat((this.ScrollTop - _startTop5) / _duration4, 6);
      _outLoop2 = true;
    }

    // 判断上一个状态和当前状态是否发生改变
    _scene2.stateChange = _scene2.state !== _scene2.prevState;
    if (_scene2.stateChange) {
      if (_scene2.onEnter && _scene2.prevState !== STATE_DURING) {
        _scene2.onEnter();
      }
      if (_scene2.duration === 0) {
        _scene2.state = _percent2 === 0 ? STATE_BEFORE : STATE_DURING;
      }
      if (_scene2.onLeave && _scene2.state !== STATE_DURING) {
        _scene2.onLeave();
      }
    }
    _scene2.prevState = _scene2.state;
    if (_scene2.isGpu) {
      this.handleGpu(_scene2);
    }

    // 进程中
    if (_scene2.onProcess && _scene2.prevPercent !== _percent2) {
      _scene2.onProcess(_percent2);
    }

    // 延迟加载只一个scene只触发一次
    if (_scene2.onLazyLoad && this.ScrollTop > _startTop5 - _scene2.lazyStartTop) {
      _scene2.onLazyLoad();
      _scene2.onLazyLoad = null;
    }
    _scene2.percent = _percent2;
    _scene2.prevPercent = _percent2;
    this.updateStyles(_scene2);
    if (_outLoop2) {
      // 有可能存在两个scene同时触发
      // break;
    }
  }
  this.prevScrollTop = this.ScrollTop;
};
EfScrollAni.prototype.handleGpu = function (scene) {
  var wcStartTop = scene.wcStartTop;
  var wcEndTop = scene.wcEndTop;
  if (this.ScrollTop < wcStartTop) {
    scene.wcState = STATE_BEFORE;
  } else if (this.ScrollTop > wcEndTop) {
    scene.wcState = STATE_AFTER;
  } else {
    scene.wcState = STATE_DURING;
  }

  // 判断上一个状态和当前状态是否发生改变
  scene.wcStateChange = scene.wcState !== scene.prevWcState;

  // 是否需要判断duration为0的情况
  if (scene.wcStateChange && scene.duration !== 0) {
    if (scene.prevWcState !== STATE_DURING) {
      // log('wcOnEnter');
      this.setSceneWillChange(scene);
    }
    if (scene.wcState !== STATE_DURING) {
      // log('wcOnLeave');
      this.resetSceneWillChange(scene);
    }
  }
  scene.prevWcState = scene.wcState;
};
EfScrollAni.prototype.setSceneWillChange = function (scene) {
  // 同步的样式
  if (scene.syncFromTo.length > 0) {
    scene.syncArrDom.forEach(function (item) {
      // 判断是否有 will-change
      item.dom.className = "".concat(item.className).concat(item.className.includes('will-change') ? '' : ' will-change');
    });
  }

  // 异步的样式
  if (scene.asyncFromTo.length > 0) {
    scene.asyncArrDom.forEach(function (item) {
      item.dom.className = "".concat(item.className).concat(item.className.includes('will-change') ? '' : ' will-change');
    });
  }
};
EfScrollAni.prototype.resetSceneWillChange = function (scene) {
  // 同步的样式
  if (scene.syncFromTo.length > 0) {
    scene.syncArrDom.forEach(function (item) {
      item.dom.className = item.className;
    });
  }

  // 异步的样式
  if (scene.asyncFromTo.length > 0) {
    scene.asyncArrDom.forEach(function (item) {
      item.dom.className = item.className;
    });
  }
};
EfScrollAni.prototype.updateStyles = function (scene) {
  // 同步
  this.updateSyncStyles(scene);
  // 异步
  this.updateAsyncStyles(scene);
};

// 同步执行
EfScrollAni.prototype.updateSyncStyles = function (scene) {
  var syncLen = scene.syncFromTo.length;
  for (var _i4 = 0; _i4 < syncLen; _i4++) {
    var _oneFromTo2 = scene.syncFromTo[_i4];
    var _dom3 = scene.syncArrDom[_i4].dom;

    // 速率变化
    var _ease2 = _oneFromTo2[1].ease;
    var _percent4 = this.getEaseValue(_ease2, scene.percent);
    var _cssTextOpacity2 = this.getCssTextOpacity(_oneFromTo2[1], _oneFromTo2[2], _percent4);
    var _cssTextMatrix2 = this.getCssTextMatrix(_oneFromTo2[1], _oneFromTo2[2], _percent4);
    var _cssTextBounds2 = this.getCssTextBounds(_oneFromTo2[1], _oneFromTo2[2], _percent4);
    if (_cssTextMatrix2) {
      _cssTextMatrix2 = this.stringToMatrix(_cssTextMatrix2);
      _cssTextMatrix2 = "transform: ".concat(_cssTextMatrix2, "; ");
    }
    _dom3.style.cssText = _cssTextMatrix2 + _cssTextOpacity2 + _cssTextBounds2;
  }
};

// 异步执行
EfScrollAni.prototype.updateAsyncStyles = function (scene) {
  // 异步执行
  var asyncLen = scene.asyncFromTo.length;
  if (asyncLen === 0) return;
  var asyncArrDuration = scene.asyncArrDuration;
  var percent = scene.percent;
  var curIndex = 0;
  for (var _i5 = 0; _i5 < asyncLen; _i5++) {
    curIndex = _i5;
    var _oneFromTo4 = scene.asyncFromTo[curIndex];
    var _domObject2 = scene.asyncArrDom[curIndex];
    var _dom5 = _domObject2.dom;
    var _multiple2 = _domObject2.multiple;
    var _block4 = asyncArrDuration[_i5];
    var _domPercent2 = 0;
    var _num2 = percent - _block4.start;
    _domPercent2 = _num2 / _block4.duration;
    if (_domPercent2 < 0) {
      _domPercent2 = 0;
    } else if (_domPercent2 > 1) {
      _domPercent2 = 1;
    }

    // 判断重复的dom元素，如还没进去区间需提前跳过&切换重复dom的当前区间
    if (_multiple2) {
      if (_domPercent2 === 0) {
        // 在所有区间之前 && 为重复元素的第一个
        var _arrClassIndex5 = scene.asyncClassMap.get(_oneFromTo4[0]);
        if (curIndex !== _arrClassIndex5[0]) {
          continue;
        }
      } else if (_domPercent2 === 1) {
        // 在所有区间之后 && 为重复元素的最后一个
        var _arrClassIndex8 = scene.asyncClassMap.get(_oneFromTo4[0]);
        if (curIndex !== _arrClassIndex8[_arrClassIndex8.length - 1]) {
          continue;
        }
      }
      // 进入当前区间需把同一个dom的其他multiple设置为true
      var _arrClassIndex10 = scene.asyncClassMap.get(_oneFromTo4[0]);
      _arrClassIndex10.forEach(function (item) {
        scene.asyncArrDom[item].multiple = true;
      });
      _domObject2.multiple = false;
    }

    // 速率变化
    var _ease4 = _oneFromTo4[1].ease;
    _domPercent2 = this.getEaseValue(_ease4, _domPercent2);
    var _cssTextOpacity4 = this.getCssTextOpacity(_oneFromTo4[1], _oneFromTo4[2], _domPercent2);
    var _cssTextMatrix4 = this.getCssTextMatrix(_oneFromTo4[1], _oneFromTo4[2], _domPercent2);
    var _cssTextBounds4 = this.getCssTextBounds(_oneFromTo4[1], _oneFromTo4[2], _domPercent2);
    if (_cssTextMatrix4) {
      _cssTextMatrix4 = this.stringToMatrix(_cssTextMatrix4);
      _cssTextMatrix4 = "transform: ".concat(_cssTextMatrix4, "; ");
    }
    _dom5.style.cssText = _cssTextMatrix4 + _cssTextOpacity4 + _cssTextBounds4;
  }
};
EfScrollAni.prototype.getCssTextOpacity = function (startOptions, endOptions, percent) {
  // console.log('startOptions', startOptions)
  if (startOptions.opacity !== undefined) {
    var _distanceValue2 = endOptions.opacity - startOptions.opacity;
    var _value4 = _distanceValue2 * percent + startOptions.opacity;
    _value4 = roundFloat(_value4, 6);
    return "opacity: ".concat(_value4);
  }
  return '';
};

// 兼容一般性能属性（width|height|top|left|right|bottom|margin|padding）
EfScrollAni.prototype.getCssTextBounds = function (startOptions, endOptions, percent) {
  // console.log('startOptions', startOptions);
  var cssText = '';
  for (var _attr in startOptions) {
    if (STATE_CSS_BOUNDS_ARRAY.indexOf(_attr) >= 0) {
      var _distanceValue4 = endOptions[_attr] - startOptions[_attr];
      var _value6 = _distanceValue4 * percent + startOptions[_attr];
      _value6 = roundFloat(_value6, 6);
      cssText += "".concat(convertToCss(_attr), ": ").concat(_value6, "px;");
    }
  }
  return cssText;
};
EfScrollAni.prototype.getCssTextMatrix = function (startOptions, endOptions, percent) {
  var skewText = '';
  var rotateText = '';
  var scaleText = '';
  var translateText = '';
  if (startOptions.skew !== undefined) {
    var _distanceValue6 = endOptions.skew - startOptions.skew;
    var _value8 = _distanceValue6 * percent + startOptions.skew;
    _value8 = roundFloat(_value8, 6);
    skewText = "skew(".concat(_value8, "deg)");
  }
  if (startOptions.rotate !== undefined) {
    var _distanceValue8 = endOptions.rotate - startOptions.rotate;
    var _value10 = _distanceValue8 * percent + startOptions.rotate;
    _value10 = roundFloat(_value10, 6);
    rotateText = "rotate(".concat(_value10, "deg)");
  }
  if (startOptions.scale !== undefined) {
    var _distanceValue10 = endOptions.scale - startOptions.scale;
    var _value12 = _distanceValue10 * percent + startOptions.scale;
    _value12 = roundFloat(_value12, 6);
    scaleText = "scale(".concat(_value12, ")");
  } else if (startOptions.scaleX !== undefined) {
    var _distanceValue12 = endOptions.scaleX - startOptions.scaleX;
    var _value14 = _distanceValue12 * percent + startOptions.scaleX;
    _value14 = roundFloat(_value14, 6);
    scaleText = "scale(".concat(_value14, ").sx");
  } else if (startOptions.scaleY !== undefined) {
    var _distanceValue14 = endOptions.scaleY - startOptions.scaleY;
    var _value16 = _distanceValue14 * percent + startOptions.scaleY;
    _value16 = roundFloat(_value16, 6);
    scaleText = "scale(".concat(_value16, ").sy");
  }
  if (startOptions.x !== undefined || startOptions.y !== undefined) {
    var _x2 = 0;
    var _y2 = 0;
    if (startOptions.x !== undefined) {
      var _distanceX2 = endOptions.x - startOptions.x;
      _x2 = _distanceX2 * percent + startOptions.x;
      _x2 = roundFloat(_x2, 6);
    }
    if (startOptions.y !== undefined) {
      var _distanceY2 = endOptions.y - startOptions.y;
      _y2 = _distanceY2 * percent + startOptions.y;
      _y2 = roundFloat(_y2, 6);
    }
    translateText = "translate(".concat(_x2, "px, ").concat(_y2, "px)");
    // console.log('translateText', translateText);
  }

  return skewText + rotateText + scaleText + translateText;
};
EfScrollAni.prototype.getEaseValue = function (ease, percent) {
  if (!ease || ease === 'linear') {
    return percent;
  }
  var easeValue = Array.isArray(ease) ? ease : Ease[ease] || Ease.linear;
  var bezier = BezierFactory.getBezierEasing(easeValue[0], easeValue[1], easeValue[2], easeValue[3]);
  return bezier.get(percent);
};
EfScrollAni.prototype.stop = function () {
  this.isRunning = false;
};

// 清除control所有状态
EfScrollAni.prototype.destroy = function () {
  (this.container || window).removeEventListener('scroll', this.scrollFn);
  (this.container || window).removeEventListener('resize', this.scrollFn);
  this.isUpdate = false;
  for (var _i6 = 0; _i6 < this.scenesArr.length; _i6++) {
    var _scene4 = this.scenesArr[_i6];
    _scene4 = null;
  }
};

// 移除scene
EfScrollAni.prototype.removeScene = function (scene) {
  var index = this.scenesArr.findIndex(function (item) {
    return item.id === scene.id;
  });
  if (index < 0) return;
  var element = this.scenesArr[index];
  this.scenesArr.splice(index, 1);
  element = null;
  this.scenesArrLen = this.scenesArr.length;
};
EfScrollAni.prototype.stringToMatrix = function (transformString) {
  // log('transformString', transformString)
  try {
    // 参数检查
    if (typeof transformString !== 'string') {
      return;
    }
    if (transformString.length === 0) {
      return;
    }
    if (['X', 'Y', 'translate3d'].some(function (item) {
      return transformString.includes(item);
    })) {
      return;
    }
    var _a2 = 1,
      _b2 = 0,
      _c2 = 0,
      _d2 = 1,
      _e2 = 0,
      _f2 = 0;
    var _reg2 = /(scale|rotate|skew|translate){1}\(.*?\)(.sx|.sy)?/g;
    var _matrixDefault2 = $M([[1, 0, 0], [0, 1, 0], [0, 0, 1]]);
    var _matrixScale2, _matrixRotate2, _matrixSkew2, _matrixTranslate2, _matrixResult2;
    transformString.match(_reg2).forEach(function (item) {
      var re = /(-)?\d+(.\d+)?/g;
      if (item.includes('rotate')) {
        var _params2 = item.match(re);
        if (_params2) {
          var _i8 = _params2[0] / 180 * Math.PI;
          _matrixRotate2 = $M([[Math.cos(_i8), -Math.sin(_i8), 0], [Math.sin(_i8), Math.cos(_i8), 0], [0, 0, 1]]);
          _matrixResult2 = _matrixResult2 ? _matrixResult2.x(_matrixRotate2) : _matrixDefault2.x(_matrixRotate2);
        }
      }
      if (item.includes('skew')) {
        var _params4 = item.match(re);
        // to fix 角度不可超过90度
        var _params4$map = _params4.map(function (a) {
            return parseFloat(a);
          }),
          _params4$map2 = _slicedToArray(_params4$map, 2),
          _params4$map2$ = _params4$map2[0],
          _i9 = _params4$map2$ === void 0 ? 0 : _params4$map2$,
          _params4$map2$2 = _params4$map2[1],
          _j = _params4$map2$2 === void 0 ? 0 : _params4$map2$2;
        _matrixSkew2 = $M([[1, Math.tan(_i9 / 180 * Math.PI), 0], [Math.tan(_j / 180 * Math.PI), 1, 0], [0, 0, 1]]);
        _matrixResult2 = _matrixResult2 ? _matrixResult2.x(_matrixSkew2) : _matrixDefault2.x(_matrixSkew2);
      }
      if (item.includes('scale')) {
        var _params6 = item.match(re);
        var _params6$map = _params6.map(function (a) {
            return parseFloat(a);
          }),
          _params6$map2 = _slicedToArray(_params6$map, 2),
          _i10 = _params6$map2[0],
          _params6$map2$ = _params6$map2[1],
          _j2 = _params6$map2$ === void 0 ? _i10 : _params6$map2$;
        // 支持scaleX或scaleY 做的特殊处理
        if (item.indexOf('.sx') > 0) {
          _j2 = 1;
        } else if (item.indexOf('.sy') > 0) {
          _i10 = 1;
        }
        _matrixScale2 = $M([[_i10, 0, 0], [0, _j2, 0], [0, 0, 1]]);
        _matrixResult2 = _matrixResult2 ? _matrixResult2.x(_matrixScale2) : _matrixDefault2.x(_matrixScale2);
      }
      if (item.includes('translate')) {
        var _params8 = item.match(re);
        var _params8$map = _params8.map(function (a) {
            return parseFloat(a);
          }),
          _params8$map2 = _slicedToArray(_params8$map, 2),
          _params8$map2$ = _params8$map2[0],
          _x3 = _params8$map2$ === void 0 ? 0 : _params8$map2$,
          _params8$map2$2 = _params8$map2[1],
          _y3 = _params8$map2$2 === void 0 ? 0 : _params8$map2$2;
        _e2 = _x3;
        _f2 = _y3;
        _matrixTranslate2 = $M([[1, 0, _x3], [0, 1, _y3], [0, 0, 1]]);
        if (_matrixResult2) {
          _matrixResult2.elements[0][2] = _x3;
          _matrixResult2.elements[1][2] = _y3;
        } else {
          _matrixDefault2.elements[0][2] = _x3;
          _matrixDefault2.elements[1][2] = _y3;
          _matrixResult2 = _matrixDefault2;
        }
      }
    });
    var _matrixResult2$elemen = _slicedToArray(_matrixResult2.elements, 3),
      _matrixResult2$elemen2 = _slicedToArray(_matrixResult2$elemen[0], 3),
      _a3 = _matrixResult2$elemen2[0],
      _a4 = _matrixResult2$elemen2[1],
      _a5 = _matrixResult2$elemen2[2],
      _matrixResult2$elemen3 = _slicedToArray(_matrixResult2$elemen[1], 3),
      _b3 = _matrixResult2$elemen3[0],
      _b4 = _matrixResult2$elemen3[1],
      _b5 = _matrixResult2$elemen3[2],
      _matrixResult2$elemen4 = _slicedToArray(_matrixResult2$elemen[2], 3),
      _c3 = _matrixResult2$elemen4[0],
      _c4 = _matrixResult2$elemen4[1],
      _c5 = _matrixResult2$elemen4[2];
    return "matrix(".concat(_a3, ", ").concat(_b3, ", ").concat(_a4, ", ").concat(_b4, ", ").concat(_a5, ", ").concat(_b5, ")");
  } catch (error) {}
};
export default EfScrollAni;